module.exports = __webpack_public_path__ + "static/media/capy_page_area04_img_cn@2x.0301a89c.png";